import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  REVIEW_TYPES,
  getReviewTypeColor,
  getReviewTypeTextColor,
  getReviewTypeText,
  getReviewTypeBorderColor
} from '../../../constants/reviewTypes';

const ReviewType = ({ 
  selectedReviewTypes = [], 
  onReviewTypeToggle,
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(REVIEW_TYPES).map((reviewType) => {
        const reviewTypeText = getReviewTypeText(reviewType);
        const isSelected = selectedReviewTypes.includes(reviewType);
        
        return (
          <FilterChip
            key={reviewType}
            label={reviewTypeText}
            isSelected={isSelected}
            onClick={() => onReviewTypeToggle(reviewType)}
            backgroundColor={getReviewTypeColor(reviewType)}
            textColor={getReviewTypeTextColor(reviewType)}
            borderColor={getReviewTypeBorderColor(reviewType)}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default ReviewType; 